import React, { useState, useEffect, useRef } from "react";
import '../../../../App.css';
import Header from "../../../../Components/Header/Header";
import LeftMenu from "../../../../Components/LeftMenu/LeftMenu";
import TopMenu from "../../../../Components/TopMenu/TopMenu";
// import CargoDamage from "../CargoDamage/CargoDamage";
// import JGrid from "../../Components/JGrid/JGrid";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt, faChevronLeft, faChevronRight,
    faXmark, faBolt, faPaperclip, faChevronDown,
    faPlus, faMinus, faMagnifyingGlass, faArrowLeft, faPlane
} from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { Button, Dropdown, Form, ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Timeline } from 'vis-timeline/standalone';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import { MultiSelect } from 'react-multi-select-component';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import JGrid from "../../Components/JGrid/JGrid";
// import JGrid from './JGrid';
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Plane from "../../../../assets/images/plane.svg";
import Planemap from "../../../../assets/images/plane_map.png";
import Planedash from "../../../../assets/images/plane_dash.png";
import Truckdash from "../../../../assets/images/truck_dash.png";
import Filter from "../../../../assets/images/filter_new.png";

import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERSDETAILS } from '../../../../Utils/conts.js';


const RFSDashboard = () => {
    const isMounted = useRef(false);
    const childRef = useRef();
    const options = [];
    const [formData, setFormData] = useState();
    const [isOpened, setIsOpened] = useState(false);
    // const [show, setShow] = useState(false);

    //   const handleClose = () => setShow(false);
    //   const handleShow = () => setShow(true);


    const [selectedDate, setSelectedDate] = useState(new Date(2025, 7, 12));
    const [showCalendar, setShowCalendar] = useState(false);

    const toggleCalendar = () => {
        setShowCalendar(!showCalendar);
    };

const handleSelect = async (date) => {
    setSelectedDate(date);
    setShowCalendar(false); // Close the calendar when a date is selected

    // Update the timeline to display the selected date
    const timelineStart = new Date(date);
    timelineStart.setHours(0, 0, 0, 0); // Start of the day
    const timelineEnd = new Date(date);
    timelineEnd.setHours(23, 59, 59, 999); // End of the day

    // Fetch truck data for the selected date
    await fetchTruckData(timelineStart, timelineEnd);

    // Update timeline window after data is fetched
    if (timeline) {
        timeline.setWindow({
            start: timelineStart,
            end: timelineEnd,
        });
    }

    // Highlight the selected date in the custom calendar
    const calendar = document.querySelector('.scrollable-calendar');
    if (calendar) {
        const days = calendar.querySelectorAll('.day');
        
        // Remove active class from all days
        days.forEach((day) => {
            day.classList.remove('active');
        });

        // Add active class to the selected date
        const formattedDate = date.toISOString().split('T')[0];
        const matchingDay = Array.from(days).find((day) => {
            const dateElement = day.querySelector('.date');
            if (dateElement) {
                const dayText = dateElement.textContent.trim();
                const dayDate = new Date(`${dayText}, ${date.getFullYear()}`);
                return dayDate.toISOString().split('T')[0] === formattedDate;
            }
            return false;
        });

        if (matchingDay) {
            matchingDay.classList.add('active');
        }
    }
};



    const [currentDate, setCurrentDate] = useState(new Date(2025, 7, 12));
    const daysToShow = 7;

    function handleNext() {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + daysToShow);
        setCurrentDate(newDate);
    }

    function handlePrevious() {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - daysToShow);
        setCurrentDate(newDate);
    }

    function isCurrentDate(date) {
        const today = new Date();
        return date.toDateString() === today.toDateString();
    }

    function getDayName(date) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return days[date.getDay()];
    }

    function getMonthAbbreviation(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[date.getMonth()];
    }

    const getStartDate = () => {
        const startDate = new Date(currentDate);
        startDate.setDate(currentDate.getDate() - 3); // 3 days before currentDate
        return startDate;
    };

    // const handleDayClick = async (date, event) => {

    //     // console.log('date');
    //     const calendar = document.querySelector('.scrollable-calendar');
    //     const days = calendar.querySelectorAll('.day');
    //     days.forEach(day => {
    //         day.classList.remove('active');
    //     });
    //     event.currentTarget.classList.add('active');
    //     // if (!apiData) {
    //     //   console.error('API data is not available');
    //     //   return;
    //     // }
    //     // Convert the date to the format "YYYY-MM-DD"
    //     const formattedDate = date.toISOString().split('T')[0];
    //     const dateObject = new Date(date);
    //     const datePart = dateObject.toISOString().split("T")[0];
    //     // try {
    //     //     const res = await withRFSToken.post(BOOKINGTRUCKGRID, { date: datePart })
    //     //         .then(function (res) {
    //     //             const innerData = res.data.response_data;
    //     //             setExportGrid(innerData.export);
    //     //         });

    //     // } catch (error) {
    //     //     console.error('Error fetching data:', error);
    //     // }

    //     setSelectedDate(date);  // Store the selected date
    //     if (childRef.current) {
    //         childRef.current.handleCloseClick();
    //     }

    //     // Update the timeline
    //     const timelineStart = new Date(date);
    //     timelineStart.setHours(0, 0, 0, 0); // Start of the day
    //     const timelineEnd = new Date(date);
    //     timelineEnd.setHours(23, 59, 59, 999); // End of the day

    //     if (timeline) {
    //         timeline.setOptions({
    //             start: timelineStart,
    //             end: timelineEnd,
    //         });
    //     }
    // };

// const handleDayClick = async (date, event) => {
//     const calendar = document.querySelector('.scrollable-calendar');
//     const days = calendar.querySelectorAll('.day');
//     days.forEach(day => {
//         day.classList.remove('active');
//     });
//     event.currentTarget.classList.add('active');

//     setSelectedDate(date);
//     setShowCalendar(false); // added this to close calendar after selecting the date

//     const timelineStart = new Date(date);
//     timelineStart.setHours(0, 0, 0, 0);
//     const timelineEnd = new Date(date);
//     timelineEnd.setHours(23, 59, 59, 999);
    
//     await fetchTruckData(timelineStart, timelineEnd);
    
//     if (timeline) {
//         timeline.setWindow({
//             start: timelineStart,
//             end: timelineEnd,
//         });
//     }
    
//     if (childRef.current) {
//         childRef.current.handleCloseClick();
//     }
// };


const handleDayClick = async (date, event) => {
    const calendar = document.querySelector('.scrollable-calendar');
    const days = calendar?.querySelectorAll('.day');
    days?.forEach(day => {
        day.classList.remove('active');
    });
    event.currentTarget.classList.add('active');

    setSelectedDate(date);
    setShowCalendar(false);

    const timelineStart = new Date(date);
    timelineStart.setHours(0, 0, 0, 0);
    const timelineEnd = new Date(date);
    timelineEnd.setHours(23, 59, 59, 999);
    await fetchTruckData(timelineStart, timelineEnd);
};


    const [selectedButton, setSelectedButton] = useState('export');
    const handleButtonClick = (button) => {
        setSelectedButton(button);
    };

    // Frequency function Section Start
    const [frequentBooking, setFrequentBooking] = useState('O');
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // const updatedData = { ...frequentBooking, [name]: value };
        const updatedData = e.target.value;
        setFrequentBooking(updatedData);
        setFormData({
            ...formData,
            trip_type: updatedData
        });
    };
    // frequency Function End

    const [selected, setSelected] = useState([]);

    const handleClick = (day) => {
        if (selected.includes(day)) {
            setSelected(selected.filter((d) => d !== day));
        } else {
            setSelected([...selected, day]);
        }
        const selectedDays = formData.selected_days.includes(day) ? formData.selected_days.filter(item => item !== day) : [...formData.selected_days, day];
        setFormData({
            ...formData,
            selected_days: selectedDays
        });
    };


    // TIMELINE START 

    const timelineRef = useRef(null);
    const svgRef = useRef(null);
    const timelineInstanceRef = useRef(null);
    const [selectedFlightDetails, setSelectedFlightDetails] = useState();
    console.log("selectedFlightDetailssss",selectedFlightDetails)
    const [showFlightDetails, setShowFlightDetails] = useState(false);
    console.log("showFlightDetailssss",showFlightDetails)
    const [filteredItems, setFilteredItems] = useState([]);
    const [flightGroup, setFlightGroup] = useState([]);
    const [clickedFlight, setClickedFlight] = useState(null);
    const [currentTime, setCurrentTime] = useState(new Date());
    const [timeline, setTimeline] = useState(null);
    const [timelineDisplay, setTimelineDisplay] = useState('T');
    const [getTruckData, setGetTruckData] = useState([]);
    const [disLoading, setDisLoading] = useState(false);
    const [connections, setConnections] = useState([]);
    const [getStation, setGetStation] = useState([]);
    const [selectedStation, setSelectedStation] = useState([]);
    const [timelineItems, setTimelineItems] = useState([]);
    const [groups, setGroups] = useState([]);
    const [prevSelectedDate,setPrevSelectedDate] =useState(null)
    // const fetchTruckData = async (startDate,endDate) => {
    //     try {
    //         const res = await withRFSToken.post('booking-truck/dashboard', {
    //             start_date:startDate,
    //             end_date:endDate
    //         })
    //             .then(function (res) {
    //                 const innerData = res.data;
    //                 setGetTruckData(innerData.Rows);
    //                 if (timelineDisplay === 'T') {
    //                     // groups = innerData.group_data;
    //                     setGroups(innerData.group_data);
    //                     const transformedData = innerData.group_data ? innerData.group_data.map(item => ({
    //                         value: item.id,
    //                         label: item.content,
    //                     })) : [];
    //                     setGetStation(transformedData)
    //                     // groups = Object.values(
    //                     //     getTruckData.reduce((acc, item) => {
    //                     //         if (!acc[item.loading_station]) {
    //                     //             acc[item.loading_station] = { id: Object.keys(acc).length + 1, content: item.loading_station };
    //                     //         }
    //                     //         return acc;
    //                     //     }, {})
    //                     // );

    //                 } else {
    //                     groups = [
    //                         { id: 1, content: 'AMS' },
    //                         { id: 2, content: 'FRA' },
    //                         { id: 3, content: 'CDG' },
    //                         { id: 4, content: 'LHR' },
    //                         { id: 5, content: 'AAG' },
    //                         { id: 6, content: 'CGO' },
    //                     ];
    //                 }
    //             });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // }
    // useEffect(() => {
    //     if (isMounted.current) return;
    //     // Call the fetchData function to fetch data from the API
    //     // fetchDataGrid();
    //     fetchTruckData();
    //     isMounted.current = true;
    // }, []);
// const fetchTruckData = async (startDate, endDate) => {
//     try {
//         const res = await withRFSToken.post('booking-truck/dashboard', {
//             start_date: startDate,
//             end_date: endDate
//         });
        
//         const innerData = res.data;

//         const allTruckData = [];
//         const stationCodes = Object.keys(innerData.response_data || {});
        
//         stationCodes.forEach(stationCode => {
//             const stationTrucks = innerData.response_data[stationCode];
//             if (Array.isArray(stationTrucks)) {
//                 stationTrucks.forEach(truck => {
//                     allTruckData.push({
//                         ...truck,
//                         loading_station: truck.booking_truck_details?.board_point_station?.station_code || stationCode,
//                         unloading_station: truck.booking_truck_details?.off_point_station?.station_code || '',
//                         truck_number: truck.booking_truck_details?.bookingtruck_no || '',
//                         loading_date_planned: `${truck.departure_date} ${truck.departure_time}`,
//                         unloading_date_planned: `${truck.arrival_date} ${truck.arrival_time}`,
//                         order_id: truck.booking_trucks_id
//                     });
//                 });
//             }
//         });
//         console.log("Processed Truck Data:", allTruckData); 
        
//         setGetTruckData(allTruckData);
        
//         if (timelineDisplay === 'T') {
//             const uniqueStations = [...new Set(allTruckData.map(item => item.loading_station))];
//             const groupData = uniqueStations.map((station, index) => ({
//                 id: index + 1,
//                 content: station
//             }));
            
//             setGroups(groupData);
            
//             const transformedData = groupData.map(item => ({
//                 value: item.id,
//                 label: item.content,
//             }));
//             setGetStation(transformedData);
//         }
//     } catch (error) {
//         console.error('Error fetching data:', error);
//         setGetTruckData([]); 
//     }
// }


const fetchTruckData = async (startDate, endDate) => {
    try {
        const res = await withRFSToken.post('booking-truck/dashboard', {
            start_date: startDate,
            end_date: endDate
        });
        
        const innerData = res.data;
        const allTruckData = [];
        const stationCodes = Object.keys(innerData.response_data || {});
        
        stationCodes.forEach(stationCode => {
            const stationTrucks = innerData.response_data[stationCode];
            if (Array.isArray(stationTrucks)) {
                stationTrucks.forEach(truck => {
                    allTruckData.push({
                        ...truck,
                        loading_station: truck.booking_truck_details?.board_point_station?.station_code || stationCode,
                        unloading_station: truck.booking_truck_details?.off_point_station?.station_code || '',
                        truck_number: truck.booking_truck_details?.bookingtruck_no || '',
                        loading_date_planned: `${truck.departure_date} ${truck.departure_time}`,
                        unloading_date_planned: `${truck.arrival_date} ${truck.arrival_time}`,
                        order_id: truck.booking_trucks_id
                    });
                });
            }
        });

        setGetTruckData(allTruckData);

        const uniqueStations = [...new Set(allTruckData
            .map(item => item.loading_station)
            .filter(station => station && station.trim() !== '')
        )];
        
        const groupData = uniqueStations.map((station, index) => ({
            id: index + 1,
            content: station
        }));
        
        setGroups(groupData);

        const transformedData = groupData.map(item => ({
            value: item.id,
            label: item.content,
        }));
        setGetStation(transformedData);

    } catch (error) {
        console.error('Error fetching data:', error);
        setGetTruckData([]);
        setGroups([]);
        setGetStation([]);
    }
};

useEffect(() => {
    if (isMounted.current) return;
     const defaultDate = new Date(2025, 7, 12); // August 12, 2025
    const startDate = new Date(defaultDate);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(defaultDate);
    endDate.setHours(23, 59, 59, 999);
    fetchTruckData(startDate, endDate);
    isMounted.current = true;
}, []);


// if (timelineDisplay === 'T') {
    //     groups = Object.values(
    //         getTruckData.reduce((acc, item) => {
    //             if (!acc[item.loading_station]) {
    //                 acc[item.loading_station] = { id: Object.keys(acc).length + 1, content: item.loading_station };
    //             }
    //             return acc;
    //         }, {})
    //     );

    // } else {
    //     groups = [
    //         { id: 1, content: 'AMS' },
    //         { id: 2, content: 'FRA' },
    //         { id: 3, content: 'CDG' },
    //         { id: 4, content: 'LHR' },
    //         { id: 5, content: 'AAG' },
    //         { id: 6, content: 'CGO' },
    //     ];
    // }
    const handleFilter = () => {
        if (selectedStation.length > 0) {
            const groups = selectedStation.map(item => ({
                id: item.value,
                content: item.label,
            }));
            setGroups(groups)
        } else {
            const groups = getStation.map(item => ({
                id: item.value,
                content: item.label,
            }));
            setGroups(groups)
        }
        setIsDataReady(false);
    }

    const formatDate = (dateString) => {
        if (!dateString) return ''; // Handle undefined or null dates
        const [day, month, yearAndTime] = dateString.split('-');
        const [year, time] = yearAndTime.split(' ');
        return `${year}-${month}-${day} ${time}`;
    };

    // let allItems = [];
    // if (timelineDisplay === 'T') {
    //     allItems = getTruckData.map((item, index) => {
    //         const group = groups.find(group => group.content === item.loading_station)?.id || null;
    //         return {
    //             id: index + 1,
    //             // group: groups[item.loading_station],
    //             group,
    //             order_id: item.order_id,
    //             content: `<div><img src="${Truckdash}" alt="Plane" /><span> ${item.truck_number}</span><span>${item.loading_station} - ${item.unloading_station}</span><p>${item.loading_date_planned?.split(' ')[1]} - ${item.unloading_date_planned?.split(' ')[1]}</p></div>`,
    //             // content: (<div><img src={Planedash} alt="Plane" /><span>{item.truck_number}</span><span>{item.loading_station} - {item.unloading_station}</span><p>{item.loading_date_planned?.split(' ')[1]} - {item.unloading_date_planned?.split(' ')[1]}</p></div>),
    //             start: formatDate(item.loading_date_planned), // Assuming this field is in '2024-12-02 14:25' format
    //             end: formatDate(item.unloading_date_planned), // Assuming this field is in '2024-12-02 20:00' format
    //             className: 'dashbord_blu', // Fixed class name
    //         }
    //     })

    // }

    let allItems = [];
if (timelineDisplay === 'T') {
    allItems = getTruckData && getTruckData.length > 0 ? getTruckData.map((item, index) => {
        const group = groups.find(group => group.content === item.loading_station)?.id || null;
        
        if (!group) return null;
        
        return {
            id: item?.id,
            group,
            // order_id: item.order_id,
            content: `<div><img src="${Truckdash}" alt="Truck" /><span> ${item.truck_number}</span><span>${item.loading_station} - ${item.unloading_station}</span><p>${item.loading_date_planned?.split(' ')[1]} - ${item.unloading_date_planned?.split(' ')[1]}</p></div>`,
            start: item.loading_date_planned,
            end: item.unloading_date_planned,
            className: 'dashbord_blu',
        };
    }).filter(item => item !== null) : [];
}

    
     else {
        allItems = [
            {
                id: 1, group: 1, content: `<div> <img src=${Planedash} /> <span> ZZZ - 142 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> <em> En Route </em></div>`, start: '2025-06-20 14:25', end: '2025-06-20 20:00', className: 'dashbord_blu', trucksList: [
                    { id: 3, group: 1, content: `<div > <img src=${Planedash} /> <span> ZZZ - 142 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> <em> Scheduled </em></div>`, start: '2025-06-21 14:25', end: '2025-06-21 24:00', className: 'dashbord_gray flight' },
                    { id: 7, group: 1, content: `<div> <img src=${Truckdash} /> <span> ZZZ- 152A </span> <p> 05:00 - 20:25 </p> <em> En Route </em></div>`, start: '2025-06-21 6:00', end: '2025-06-21 18:00', className: 'dashbord_blu truck' },
                    { id: 8, group: 1, content: `<div> <img src=${Truckdash} /> <span> ZZZ - 612A </span> <p> 13:00 - 06:35 </p> <em> Arrived </em> <pre> BRU - AMS </pre> </div>`, start: '2025-06-21 8:00', end: '2025-06-21 20:00', className: 'dashbord_gr truck' },
                    { id: 9, group: 1, content: `<div> <img src=${Truckdash} /> <span> ZZZ - 187 </span> <p> 14:00 - 22:20 </p> <em> En Route </em>  <pre> BRU - AMS </pre> </div>`, start: '2025-06-21 10:00', end: '2025-06-21 17:00', className: 'dashbord_org truck' },
                ]
            },
            {
                id: 2, group: 2, content: 'ZZZ - 924', start: '2024-11-18 14:25', end: '2024-11-18 17:35', className: 'bg-green', trucksList: [
                    { id: 3, group: 2, content: 'ZZZ - 924', start: '2024-11-18 14:50', end: '2024-11-18 20:15', className: 'bg-green flight' },
                    { id: 7, group: 2, content: '<div> <span> ZZZ - 925B </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-11-17 15:00', end: '2024-11-17 18:00', className: 'bg-green truck' },
                    { id: 8, group: 2, content: '<div> <span> ZZZ - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-11-17 16:00', end: '2024-11-17 19:00', className: 'bg-orange truck' },
                ]
            },
            {
                id: 3, group: 3, content: `<div> <img src=${Planedash} /> <span> ZZZ - 272 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> <em> Arrived </em></div>`, start: '2024-12-18 14:50', end: '2024-12-18 20:15', className: 'dashbord_gr', trucksList: [
                    { id: 3, group: 3, content: '<div> <span> ZZZ - 272 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> </div>', start: '2024-12-18 14:50', end: '2024-12-18 20:15', className: 'dashbord_gray flight' },
                    { id: 7, group: 3, content: '<div> <span> ZZZ - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-12-17 15:00', end: '2024-12-17 18:00', className: 'dashbord_gr truck' },
                    { id: 8, group: 3, content: '<div> <span> ZZZ - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-12-17 16:00', end: '2024-12-17 19:00', className: 'dashbord_blu truck' },
                ]
            },
            {
                id: 4, group: 4, content: 'ZZZ - 129', start: '2024-11-03 14:05', end: '2024-11-03 20:15', className: 'bg-blue', trucksList: [
                    { id: 3, group: 4, content: 'ZZZ - 129', start: '2024-11-03 14:50', end: '2024-11-03 20:15', className: 'bg-green' },
                    { id: 7, group: 4, content: 'Truck 1 - Cargo', start: '2024-11-02 15:00', end: '2024-11-02 18:00', className: 'bg-green' },
                    { id: 8, group: 4, content: 'Truck 2 - Cargo', start: '2024-11-02 16:00', end: '2024-11-02 19:00', className: 'bg-orange' },
                ]
            },
            {
                id: 5, group: 5, content: 'ZZZ - 156', start: '2024-11-04 15:55', end: '2024-11-04 23:30', className: 'bg-blue', trucksList: [
                    { id: 3, group: 5, content: 'ZZZ - 156', start: '2024-11-03 14:50', end: '2024-11-03 20:15', className: 'bg-green' },
                    { id: 7, group: 5, content: 'Truck 1 - Cargo', start: '2024-11-02 15:00', end: '2024-11-02 18:00', className: 'bg-green' },
                    { id: 8, group: 5, content: 'Truck 2 - Cargo', start: '2024-11-02 16:00', end: '2024-11-02 19:00', className: 'bg-orange' },
                ]
            },
            {
                id: 6, group: 6, content: 'ZZZ - 815 (Delayed)', start: '2024-11-04 20:30', end: '2024-11-04 23:40', className: 'bg-orange', trucksList: [
                    { id: 3, group: 6, content: 'ZZZ - 815 (Delayed)', start: '2024-11-03 14:50', end: '2024-11-03 20:15', className: 'bg-green' },
                    { id: 7, group: 6, content: 'Truck 1 - Cargo', start: '2024-11-02 15:00', end: '2024-11-02 18:00', className: 'bg-green' },
                    { id: 8, group: 6, content: 'Truck 2 - Cargo', start: '2024-11-02 16:00', end: '2024-11-02 19:00', className: 'bg-orange' },
                ]
            },
        ];

        console.log("allItemssss",allItems)
        console.log("groupssss",groups)



        // [
        //     { id: 1, group: 1, content: `<div> <img src=${Planedash} /> <span> ZZZ - 142 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15</div>`, start: '2024-12-02 14:25', end: '2024-12-02 20:00', className: 'dashbord_blu', },
        //     { id: 2, group: 2, content: 'ZZZ - 924', start: '2024-11-02 14:25', end: '2024-11-02 17:35', className: 'bg-green', },
        //     { id: 3, group: 3, content: `<div> <img src=${Planedash} /> <span> ZZZ - 272 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p></div>`, start: '2024-12-02 14:50', end: '2024-12-02 20:15', className: 'dashbord_gr', },
        //     { id: 4, group: 4, content: 'ZZZ - 129', start: '2024-11-03 14:05', end: '2024-11-03 20:15', className: 'bg-blue', },
        //     { id: 5, group: 5, content: 'ZZZ - 156', start: '2024-11-04 15:55', end: '2024-11-04 23:30', className: 'bg-blue', },
        //     { id: 6, group: 6, content: 'ZZZ - 815 (Delayed)', start: '2024-11-04 20:30', end: '2024-11-04 23:40', className: 'bg-orange', },
        // ];
    }
    // const allItems = [
    //     {
    //         id: 1, group: 1, content: `<div> <img src=${Planedash} /> <span> ZZZ - 142 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> <em> En Route </em></div>`, start: '2024-12-02 14:25', end: '2024-12-02 20:00', className: 'dashbord_blu', trucksList: [
    //             { id: 3, group: 1, content: `<div > <img src=${Planedash} /> <span> ZZZ - 142 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> <em> Scheduled </em></div>`, start: '2024-12-02 14:25', end: '2024-12-02 24:00', className: 'dashbord_gray flight' },
    //             { id: 7, group: 1, content: `<div> <img src=${Truckdash} /> <span> ZZZ- 152A </span> <p> 05:00 - 20:25 </p> <em> En Route </em></div>`, start: '2024-12-01 6:00', end: '2024-12-01 18:00', className: 'dashbord_blu truck' },
    //             { id: 8, group: 1, content: `<div> <img src=${Truckdash} /> <span> ZZZ - 612A </span> <p> 13:00 - 06:35 </p> <em> Arrived </em> <pre> BRU - AMS </pre> </div>`, start: '2024-12-01 8:00', end: '2024-12-01 20:00', className: 'dashbord_gr truck' },
    //             { id: 9, group: 1, content: `<div> <img src=${Truckdash} /> <span> ZZZ - 187 </span> <p> 14:00 - 22:20 </p> <em> En Route </em>  <pre> BRU - AMS </pre> </div>`, start: '2024-12-01 10:00', end: '2024-12-01 17:00', className: 'dashbord_org truck' },
    //         ]
    //     },
    //     {
    //         id: 2, group: 2, content: 'ZZZ - 924', start: '2024-11-02 14:25', end: '2024-11-02 17:35', className: 'bg-green', trucksList: [
    //             { id: 3, group: 2, content: 'ZZZ - 924', start: '2024-11-03 14:50', end: '2024-11-03 20:15', className: 'bg-green' },
    //             { id: 7, group: 2, content: '<div> <span> ZZZ - 925B </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-11-02 15:00', end: '2024-11-02 18:00', className: 'bg-green' },
    //             { id: 8, group: 2, content: '<div> <span> ZZZ - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-11-02 16:00', end: '2024-11-02 19:00', className: 'bg-orange' },
    //         ]
    //     },
    //     {
    //         id: 3, group: 3, content: `<div> <img src=${Planedash} /> <span> ZZZ - 272 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> <em> Arrived </em></div>`, start: '2024-12-02 14:50', end: '2024-12-02 20:15', className: 'dashbord_gr', trucksList: [
    //             { id: 3, group: 3, content: '<div> <span> ZZZ - 272 </span>   <span> AMS - MIA </span> <p> 14:50 - 20:15 </p> </div>', start: '2024-12-02 14:50', end: '2024-12-02 20:15', className: 'dashbord_gray' },
    //             { id: 7, group: 3, content: '<div> <span> ZZZ - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-12-01 15:00', end: '2024-12-01 18:00', className: 'dashbord_gr' },
    //             { id: 8, group: 3, content: '<div> <span> ZZZ - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2024-12-01 16:00', end: '2024-12-01 19:00', className: 'dashbord_blu' },
    //         ]
    //     },
    //     {
    //         id: 4, group: 4, content: 'ZZZ - 129', start: '2024-11-03 14:05', end: '2024-11-03 20:15', className: 'bg-blue', trucksList: [
    //             { id: 3, group: 4, content: 'ZZZ - 129', start: '2024-11-03 14:50', end: '2024-11-03 20:15', className: 'bg-green' },
    //             { id: 7, group: 4, content: 'Truck 1 - Cargo', start: '2024-11-02 15:00', end: '2024-11-02 18:00', className: 'bg-green' },
    //             { id: 8, group: 4, content: 'Truck 2 - Cargo', start: '2024-11-02 16:00', end: '2024-11-02 19:00', className: 'bg-orange' },
    //         ]
    //     },
    //     {
    //         id: 5, group: 5, content: 'ZZZ - 156', start: '2024-11-04 15:55', end: '2024-11-04 23:30', className: 'bg-blue', trucksList: [
    //             { id: 3, group: 5, content: 'ZZZ - 156', start: '2024-11-03 14:50', end: '2024-11-03 20:15', className: 'bg-green' },
    //             { id: 7, group: 5, content: 'Truck 1 - Cargo', start: '2024-11-02 15:00', end: '2024-11-02 18:00', className: 'bg-green' },
    //             { id: 8, group: 5, content: 'Truck 2 - Cargo', start: '2024-11-02 16:00', end: '2024-11-02 19:00', className: 'bg-orange' },
    //         ]
    //     },
    //     {
    //         id: 6, group: 6, content: 'ZZZ - 815 (Delayed)', start: '2024-11-04 20:30', end: '2024-11-04 23:40', className: 'bg-orange', trucksList: [
    //             { id: 3, group: 6, content: 'ZZZ - 815 (Delayed)', start: '2024-11-03 14:50', end: '2024-11-03 20:15', className: 'bg-green' },
    //             { id: 7, group: 6, content: 'Truck 1 - Cargo', start: '2024-11-02 15:00', end: '2024-11-02 18:00', className: 'bg-green' },
    //             { id: 8, group: 6, content: 'Truck 2 - Cargo', start: '2024-11-02 16:00', end: '2024-11-02 19:00', className: 'bg-orange' },
    //         ]
    //     },
    // ];

    const truckDetailsForFlight = [
        { id: 7, group: 'Truck 1', content: 'ZZZ-152A', start: '2024-10-13 05:00', end: '2024-10-13 20:25', flightId: 1, className: 'bg-green' },
        { id: 8, group: 'Truck 2', content: 'ZZZ-722B', start: '2024-10-13 02:00', end: '2024-10-13 21:35', flightId: 1, className: 'bg-green' },
        { id: 9, group: 'Truck 3', content: 'ZZZ-612A', start: '2024-10-13 13:00', end: '2024-10-13 06:35', flightId: 2, className: 'bg-blue' },
        { id: 10, group: 'Truck 4', content: 'ZZZ-422', start: '2024-10-14 07:00', end: '2024-10-14 16:05', flightId: 3, className: 'bg-green' },
        { id: 11, group: 'Truck 5', content: 'ZZZ-681A', start: '2024-10-14 09:00', end: '2024-10-14 20:10', flightId: 4, className: 'bg-green' },
        { id: 12, group: 'Truck 6', content: 'ZZZ-925B', start: '2024-10-17 20:15', end: '2024-10-17 05:25', flightId: 5, className: 'bg-blue' },
    ];


    // const groups = [
    //     { id: 1, content: 'AMS' },
    //     { id: 2, content: 'FRA' },
    //     { id: 3, content: 'CDG' },
    //     { id: 4, content: 'LHR' },
    //     { id: 5, content: 'AAG' },
    //     { id: 6, content: 'CGO' },
    // ];

    const truckGroups = [
        { id: 'Truck 1', content: 'Truck 1' },
        { id: 'Truck 2', content: 'Truck 2' },
        { id: 'Truck 3', content: 'Truck 3' },
        { id: 'Truck 4', content: 'Truck 4' },
        { id: 'Truck 5', content: 'Truck 5' },
        { id: 'Truck 6', content: 'Truck 6' },
    ];

    // const drawConnections = () => {
    //     // if (timelineRef.current) {
    //     //     timelineRef.current.destroy();
    //     //   }
    //     const svg = svgRef.current;
    //     if(!svg) return;
    //     svg.innerHTML = ""; // Clear previous lines
    //     filteredItems?.forEach((item, index) => {
    //         // Get the flight element
    //         const allElements = Array.from(document.querySelectorAll('.vis-item'));
    //         const flightElement = allElements[0]; // Assuming the first is the flight element, update if needed.

    //         if (!flightElement) return;

    //         const flightRect = flightElement.getBoundingClientRect();
    //         const flightX = flightRect.left; // X-coordinate of the left line
    //         const flightY = flightRect.top + flightRect.height / 2; // Middle of the left line

    //         item.trucksList.forEach((truck, trindex) => {
    //             const allElementstruck = Array.from(document.querySelectorAll('.vis-item'));
    //             if (trindex !== 0) {
    //                 const truckElement = allElementstruck[trindex];
    //                 if (!truckElement) return;

    //                 const truckRect = truckElement.getBoundingClientRect();
    //                 const truckX = truckRect.left + truckRect.width; // X-coordinate of the right line
    //                 const truckY = truckRect.top + truckRect.height / 2; // Middle of the right line

    //                 // Create an SVG path for a curved line
    //                 const path = document.createElementNS("http://www.w3.org/2000/svg", "path");

    //                 // Define the curved path using SVG path commands
    //                 const verticalOffset = Math.abs(flightY - truckY) / 2; // Adjust dynamically based on spacing
    //                 const pathData = `M ${flightX},${flightY} 
    //                             C ${flightX - 50},${flightY - verticalOffset} 
    //                               ${truckX + 50},${truckY - verticalOffset} 
    //                               ${truckX},${truckY}`;

    //                 path.setAttribute("d", pathData);
    //                 path.setAttribute("fill", "none");
    //                 path.setAttribute("stroke", "black");
    //                 path.setAttribute("stroke-width", "2");

    //                 svg.appendChild(path);
    //             }
    //         });
    //     });
    // };

    // const drawConnections = () => {
    //     const svg = svgRef.current;
    //     if (!svg) return;

    //     svg.innerHTML = ""; // Clear previous lines
    //     filteredItems?.forEach((item, index) => {
    //         // Get the flight element
    //         const allElements = Array.from(document.querySelectorAll('.vis-item'));
    //         const flightElement = allElements[0]; // Assuming the first is the flight element, update if needed.

    //         if (!flightElement) return;

    //         const flightRect = flightElement.getBoundingClientRect();
    //         const flightX = flightRect.left; // X-coordinate of the left line
    //         const flightY = flightRect.top + flightRect.height / 2; // Middle of the left line

    //         item.trucksList.forEach((truck, trindex) => {
    //             const allElementstruck = Array.from(document.querySelectorAll('.vis-item'));
    //             if (trindex !== 0) {
    //                 const truckElement = allElementstruck[trindex];
    //                 if (!truckElement) return;

    //                 const truckRect = truckElement.getBoundingClientRect();
    //                 const truckX = truckRect.left + truckRect.width; // X-coordinate of the right line
    //                 const truckY = truckRect.top + truckRect.height / 2; // Middle of the right line

    //                 // Create an SVG path for a curved line
    //                 const path = document.createElementNS("http://www.w3.org/2000/svg", "path");

    //                 // Calculate the vertical offset
    //                 const verticalOffset = Math.abs(flightY - truckY) / 10;

    //                 // Check the curve direction based on truckY - flightY
    //                 const isPositive = truckY - flightY > 0;

    //                 // Define the curved path using SVG path commands
    //                 const pathData = isPositive
    //                     ? `M ${flightX},${flightY} 
    //                     C ${flightX - 50},${flightY + verticalOffset} 
    //                         ${truckX + 50},${truckY + verticalOffset} 
    //                         ${truckX},${truckY}`
    //                     : `M ${flightX},${flightY} 
    //                     C ${flightX - 50},${flightY - verticalOffset} 
    //                         ${truckX + 50},${truckY - verticalOffset} 
    //                         ${truckX},${truckY}`;

    //                 path.setAttribute("d", pathData);
    //                 path.setAttribute("fill", "none");
    //                 path.setAttribute("stroke", "black");
    //                 path.setAttribute("stroke-width", "2");

    //                 svg.appendChild(path);
    //             }
    //         });
    //     });
    // };

    // const drawConnections = () => {
    //     const svg = svgRef.current;
    //     if (!svg) return;

    //     svg.innerHTML = ""; // Clear previous SVG paths

    //     filteredItems?.forEach((item) => {
    //         // Find the flight element by its data-id
    //         const flightElement = document.querySelector(`.vis-item.flight`);
    //         if (!flightElement) {
    //             // console.warn(`Flight element with id flight-${item.id} not found`);
    //             return; // Skip drawing if the flight element is missing
    //         }

    //         const flightRect = flightElement.getBoundingClientRect();
    //         const flightX = flightRect.left; // X-coordinate of the left line
    //         const flightY = flightRect.top + flightRect.height / 2; // Middle of the left line

    //         // Iterate over the trucksList for this flight
    //         item.trucksList.forEach((truck, trindex) => {
    //             const truckElements = document.querySelectorAll('.vis-item.truck'); // All truck elements
    //             const truckElement = truckElements[trindex]; // Get the truck element corresponding to this index

    //             if (!truckElement) return;

    //             const truckRect = truckElement.getBoundingClientRect();
    //             const truckX = truckRect.left + truckRect.width;
    //             const truckY = truckRect.top + truckRect.height / 2;

    //             // Create an SVG path for each truck
    //             const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    //             const verticalOffset = Math.abs(flightY - truckY) / 10;
    //             const isPositive = truckY - flightY > 0;

    //             const pathData = isPositive
    //                 ? `M ${flightX},${flightY} 
    //                        C ${flightX - 50},${flightY + verticalOffset} 
    //                          ${truckX + 50},${truckY + verticalOffset} 
    //                          ${truckX},${truckY}`
    //                 : `M ${flightX},${flightY} 
    //                        C ${flightX - 50},${flightY - verticalOffset} 
    //                          ${truckX + 50},${truckY - verticalOffset} 
    //                          ${truckX},${truckY}`;

    //             path.setAttribute("d", pathData);
    //             path.setAttribute("fill", "none");
    //             path.setAttribute("stroke", "black");
    //             path.setAttribute("stroke-width", "2");

    //             svg.appendChild(path);
    //         });
    //     });
    // };

    // const drawConnections = () => {
    //     const svg = svgRef.current;
    //     if (!svg) return;

    //     svg.innerHTML = ""; // Clear previous SVG paths

    //     filteredItems?.forEach((item) => {
    //         // Find the flight element by its data-id
    //         const flightElement = document.querySelector(`.vis-item.flight`);
    //         if (!flightElement) {
    //             // console.warn(`Flight element with id flight-${item.id} not found`);
    //             return; // Skip drawing if the flight element is missing
    //         }

    //         const flightRect = flightElement.getBoundingClientRect();
    //         const flightX = flightRect.left; // X-coordinate of the left line
    //         const flightY = flightRect.top + flightRect.height / 2; // Middle of the left line

    //         // Iterate over the trucksList for this flight
    //         item.trucksList.forEach((truck, trindex) => {
    //             const truckElements = document.querySelectorAll('.vis-item.truck'); // All truck elements
    //             const truckElement = truckElements[trindex]; // Get the truck element corresponding to this index

    //             if (!truckElement) return;

    //             const truckRect = truckElement.getBoundingClientRect();
    //             const truckX = truckRect.left + truckRect.width;
    //             const truckY = truckRect.top + truckRect.height / 2;

    //             // Create an SVG path for each truck
    //             const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    //             const verticalOffset = Math.abs(flightY - truckY) / 10;
    //             const isPositive = truckY - flightY > 0;

    //             const pathData = isPositive
    //                 ? `M ${flightX},${flightY} 
    //                        C ${flightX - 50},${flightY + verticalOffset} 
    //                          ${truckX + 50},${truckY + verticalOffset} 
    //                          ${truckX},${truckY}`
    //                 : `M ${flightX},${flightY} 
    //                        C ${flightX - 50},${flightY - verticalOffset} 
    //                          ${truckX + 50},${truckY - verticalOffset} 
    //                          ${truckX},${truckY}`;

    //             path.setAttribute("d", pathData);
    //             path.setAttribute("fill", "none");
    //             path.setAttribute("stroke", "black");
    //             path.setAttribute("stroke-width", "2");

    //             svg.appendChild(path);
    //         });
    //     });
    // };


    const drawConnections = () => {
    const svg = svgRef.current;
    if (!svg || !filteredItems || filteredItems.length === 0) return;

    svg.innerHTML = "";
    console.log("filteredItemssss",filteredItems)

    filteredItems.forEach((item) => {
        if (!item.trucksList || item.trucksList.length === 0) return;

        const timelineContainer = timelineRef.current;
        if (!timelineContainer) return;

        const containerRect = timelineContainer.getBoundingClientRect();

        // Find the truck element (first item in trucksList is the truck)
        const truckElement = document.querySelector('.vis-item.truck');
        if (!truckElement) return;

        const truckRect = truckElement.getBoundingClientRect();
        const truckX = truckRect.right - containerRect.left;
        const truckY = truckRect.top - containerRect.top + truckRect.height / 2;

        // Find all flight elements and connect each to the truck
        const allFlightElements = document.querySelectorAll('.vis-item.flight');
        
        if (allFlightElements.length === 0) return;

        allFlightElements.forEach((flightElement) => {
            const flightRect = flightElement.getBoundingClientRect();
            const flightX = flightRect.left - containerRect.left;
            const flightY = flightRect.top - containerRect.top + flightRect.height / 2;

            // Create SVG path connecting truck to flight
            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            
            const verticalOffset = Math.abs(truckY - flightY) / 4;
            
            const controlPoint1X = truckX + 40;
            const controlPoint1Y = truckY;
            const controlPoint2X = flightX - 30;
            const controlPoint2Y = flightY;

            const pathData = `M ${truckX},${truckY} C ${controlPoint1X},${controlPoint1Y} ${controlPoint2X},${controlPoint2Y} ${flightX},${flightY}`;

            path.setAttribute("d", pathData);
            path.setAttribute("fill", "none");
            path.setAttribute("stroke", "#666");
            path.setAttribute("stroke-width", "2");
            path.setAttribute("stroke-dasharray", "5,5");
            path.setAttribute("opacity", "0.7");
            path.setAttribute("transform", "translate(0, 8)");  // to move connections ups and downs. - is up and without - is down

            svg.appendChild(path);
        });
    });
};

    // const parseDate = (dateString) => {
    //     // Replace the space with 'T' for ISO format compatibility
    //     return new Date(dateString.replace(' ', 'T'));
    // };

    // const oldestDate = filteredItems.reduce((oldest, item) => {
    //     const currentStartDate = parseDate(item.start); // Convert start date to Date object
    //     return currentStartDate < oldest ? currentStartDate : oldest;
    // }, parseDate(filteredItems[0].start)); // Initialize with the first item's start date

    // console.log('oldestDate', oldestDate.toISOString());
    const [isDataReady, setIsDataReady] = useState(false);

    useEffect(() => {
        if (allItems && allItems.length > 0) {
            setIsDataReady(true);
        }
    }, [allItems]);

    // useEffect(() => {
    //     if (timelineDisplay) {
    //         const timelineStart = new Date(currentTime);
    //         // timelineStart.setHours(timelineStart.getHours() - 8); // Show 2 hours before
    //         timelineStart.setHours(0, 0, 0, 0); // Show 2 hours before
    //         const timelineEnd = new Date(currentTime);
    //         // timelineEnd.setHours(timelineEnd.getHours() + 8);
    //         timelineEnd.setHours(23, 59, 59, 999);

    //         const innertimelineStart = new Date(currentTime);
    //         innertimelineStart.setHours(-20, 0, 0, 0); // Show 2 hours before
    //         const innertimelineEnd = new Date(currentTime);
    //         innertimelineEnd.setHours(23, 59, 59, 999);

    //         const options = {
    //             stack: true,
    //             margin: {
    //                 item: 10, // Space between items
    //                 axis: 10, // Space between items and the axis
    //             },
    //             start: showFlightDetails ? innertimelineStart : timelineStart,
    //             end: showFlightDetails ? innertimelineEnd : timelineEnd,
    //             editable: false,
    //             zoomable: true,
    //             horizontalScroll: true,
    //             itemHeight: 51,
    //             minHeight: '85dvh',
    //             orientation: { axis: 'both', item: 'bottom' }, // axis: 'both'/ 'top'/ 'bottom'
    //             zoomMin: showFlightDetails ? 1200000 : 86400000,
    //             zoomMax: 432000000 //31536000000
    //         };

    //         // const timeline = new Timeline(timelineRef.current, showFlightDetails ? filteredItems : allItems, showFlightDetails ? truckGroups : groups, options);
    //         const timeline = new Timeline(timelineRef.current, showFlightDetails ? filteredItems[0].trucksList : allItems, showFlightDetails ? [{ id: clickedFlight?.group, content: clickedFlight?.content, start: clickedFlight?.start, end: clickedFlight?.end }] : groups, options);

    //         timeline.on("rangechanged", function (props) {
    //             const start = props.start;
    //             const end = props.end;
    //             fetchTruckData(start, end)
    //         })

    //         // Handle item click event to show truck details for specific flight
    //         timeline.on('click', function (properties) {
    //             if (properties.item) {
    //                 const clickedItem = allItems.find(item => item.id === properties.item);
    //                 console.log("clickedItemmmmm",clickedItem)
    //                 if (clickedItem) {
    //                     // Filter trucks related to the clicked flight
    //                     const relatedTrucks = truckDetailsForFlight.filter(truck => truck.flightId === clickedItem.id);

    //                     // // const relatedTrucks = clickedItem.trucksList;
    //                     // setFilteredItems(clickedItem.trucksList);
    //                     // setShowFlightDetails(true);
    //                     // setClickedFlight(clickedItem); // Store clicked flight ID
    //                     handleSidePanelClick(clickedItem)
    //                     // setSelectedFlightDetails(clickedItem);
    //                 }
    //             }
    //         });

    //         // Destroy previous timeline instance if it exists
    //         // if (timeline.current) {
    //         //     timeline.current.destroy();
    //         // }

    //         // Initialize the timeline instance
    //         // timeline.current = new Timeline(container, items, groups);

    //         timeline.on("changed", () => {
    //             requestAnimationFrame(drawConnections); // Ensure DOM rendering
    //         });

    //         setTimeout(() => {
    //             drawConnections(); // Initial drawing
    //         }, 200); // Delay to allow rendering

    //         // if (timeline) {
    //         //     timeline.on("changed", () => {
    //         //         const container = timelineRef.current;
    //         //         if (container) {
    //         //             drawLines(container, allItems.get(1), allItems.get());
    //         //         }
    //         //     });
    //         // }

    //         setTimeline(timeline);
    //         return () => timeline.destroy();
    //     }


    // }, [isDataReady, showFlightDetails, filteredItems, timelineDisplay]);



    

    // const handleSidePanelClick = async (item) => {
    //     console.log('itemnnn', item);
    //     if (!showFlightDetails) {
    //         if (timelineDisplay === 'F') {
    //             setSelectedFlightDetails(item);
    //         } else {
    //             setDisLoading(true);
    //             try {
    //                 const res = await withRFSToken.post('booking-truck/connected-flights', { bookingtruck_date_id: item.id })
    //                     .then(function (res) {
    //                         const innerData = res.data.response_data;
    //                         console.log("innerDataaaaaa",innerData)
    //                         setSelectedFlightDetails(innerData);
    //                         setDisLoading(false);
    //                     });
    //             } catch (error) {
    //                 console.error('Error fetching data:', error);
    //             }
    //         }
    //     }
    // }


// useEffect(() => {
//     if (!timelineDisplay || !timelineRef.current) return;
// let timelineStart, timelineEnd;

//     if (selectedDate && selectedDate !== prevSelectedDate) {
//         timelineStart = new Date(selectedDate);
//         timelineStart.setHours(0, 0, 0, 0);
//         timelineEnd = new Date(selectedDate);
//         timelineEnd.setHours(23, 59, 59, 999);
//         setPrevSelectedDate(selectedDate);
//     } else if (timeline) {
//         const { start, end } = timeline.getWindow();
//         timelineStart = start;
//         timelineEnd = end;
//     } else {
//         timelineStart = new Date();
//         timelineStart.setHours(0, 0, 0, 0);
//         timelineEnd = new Date();
//         timelineEnd.setHours(23, 59, 59, 999);
//     }

    
//     // const timelineStart = new Date(baseDate);
//     // timelineStart.setHours(0, 0, 0, 0);
//     // const timelineEnd = new Date(baseDate);
//     // timelineEnd.setHours(23, 59, 59, 999);

//     const options = {
//         stack: true,
//         margin: { item: 10, axis: 10 },
//         start: timelineStart,
//         end: timelineEnd,
//         editable: false,
//         zoomable: true,
//         horizontalScroll: true,
//         itemHeight: 51,
//         minHeight: '85dvh',
//         orientation: { axis: 'both', item: 'bottom' }, // axis: 'both'/ 'top'/ 'bottom'
//         zoomMin: showFlightDetails ? 1200000 : 86400000,
//         zoomMax: 432000000, //31536000000
//     };

//     let displayItems = [];
//     let displayGroups = [];

//     if (showFlightDetails && filteredItems?.[0]?.trucksList) {
//         displayItems = filteredItems[0].trucksList;
        
//         // Create unique groups from items to avoid duplicate group IDs
//         const uniqueGroups = new Map();
//         filteredItems[0].trucksList.forEach((item) => {
//             const groupId = item.group !== undefined && item.group !== null ? item.group : 0;
//             if (!uniqueGroups.has(groupId)) {
//                 // Use a simple label for groups
//                 uniqueGroups.set(groupId, {
//                     id: groupId,
//                     content: groupId === 0 ? 'Truck' : `Flight ${groupId}`,
//                 });
//             }
//         });
//         displayGroups = Array.from(uniqueGroups.values());
//     } else {
//         displayItems =
//             getTruckData?.length > 0
//                 ? getTruckData
//                       .map((item) => {
//                           const group =
//                               groups.find(
//                                   (g) => g.content === item.loading_station
//                               )?.id || null;
//                           if (!group) return null;
//                           return {
//                               id: item.id,
//                               group,
//                               content: `
//                                 <div>
//                                     <img src="${Truckdash}" alt="Truck" />
//                                     <span>${item.truck_number}</span>
//                                     <span>${item.loading_station} - ${item.unloading_station}</span>
//                                     <p>${item.loading_date_planned?.split(' ')[1]} - ${item.unloading_date_planned?.split(' ')[1]}</p>
//                                 </div>`,
//                               start: item.loading_date_planned,
//                               end: item.unloading_date_planned,
//                               className: 'dashbord_blu',
//                           };
//                       })
//                       .filter(Boolean)
//                 : [];

//         displayGroups = groups;
//     }

//     const timelineInstance = new Timeline(
//         timelineRef.current,
//         displayItems,
//         displayGroups,
//         options
//     );

//     let isUserInteraction = false;

//     timelineInstance.on('rangechange', () => {
//         isUserInteraction = true;
//     });

//     timelineInstance.on('rangechanged', (props) => {
//         if (isUserInteraction && !showFlightDetails) {
//             console.log("isUserInteractionnnn",isUserInteraction)
//             const { start, end } = props;
//             const rangeInDays = (end - start) / (1000 * 60 * 60 * 24);
//             if (rangeInDays >= 1) {
//                 fetchTruckData(start, end);
//             }
//             isUserInteraction = false;
//         }
//     });

//     let clickTimeout = null;
//     const clickDelay = 250; 

//     const handleSingleClick = (properties) => {
//         if (properties.item && !showFlightDetails) {
//             const clickedItem = getTruckData.find(
//                 (item) => item.id === properties.item
//             );
//             if (clickedItem) handleSidePanelClick(clickedItem);
//         }
//     };

//     const handleDoubleClickWrapper = async (properties) => {
//         if (!showFlightDetails) {
//             await handleDoubleClick(
//                 properties,
//                 getTruckData,
//                 withRFSToken,
//                 setDisLoading,
//                 setFilteredItems,
//                 setShowFlightDetails,
//                 setClickedFlight,
//                 setSelectedFlightDetails,
//             );
//         }
//     };

//     timelineInstance.on('click', (properties) => {
//         if (clickTimeout) clearTimeout(clickTimeout);
//         clickTimeout = setTimeout(() => {
//             handleSingleClick(properties);
//             clickTimeout = null;
//         }, clickDelay);
//     });

//     timelineInstance.on('doubleClick', (properties) => {
//         if (clickTimeout) {
//             clearTimeout(clickTimeout); 
//             clickTimeout = null;
//         }
//         handleDoubleClickWrapper(properties);
//     });

//     timelineInstance.on('changed', () => {
//         requestAnimationFrame(drawConnections);
//     });

//     setTimeout(() => {
//         drawConnections();
//     }, 200);

//     setTimeline(timelineInstance);

//     return () => {
//         if (clickTimeout) clearTimeout(clickTimeout);
//         timelineInstance.destroy();
//     };
// }, [
//     timelineDisplay,
//     getTruckData,
//     showFlightDetails,
//     filteredItems,
//     groups,
//     clickedFlight,
//     currentTime,
// ]);


const handleDoubleClickForTimeline = async (clickedItem) => {
    if (!clickedItem) return;

    try {
        setDisLoading(true);
        const res = await withRFSToken.post('booking-truck/connected-flights', {
            bookingtruck_date_id: clickedItem.id,
        });

        const innerData = res.data.response_data;
        
        // Create truck datetime strings
        const truckDepartureDateTime = `${innerData.booking_data?.departure_date} ${innerData.booking_data?.departure_time}`;
        const truckArrivalDateTime = `${innerData.booking_data?.arrival_date} ${innerData.booking_data?.arrival_time}`;
        
        // Get flight count and calculate truck group position (middle)
        const flightCount = innerData?.awbs?.length || 0;
        const truckGroupIndex = Math.floor(flightCount / 2); // Truck in the middle
        
        // Create flight items for timeline - distribute flights on both sides of truck
        const flightItems = innerData?.awbs?.map((flight, index) => {
            // Distribute flights: half before truck, half after truck
            let groupIndex;
            if (index < truckGroupIndex) {
                // Flights before truck: groups 0, 1, 2, ...
                groupIndex = index;
            } else {
                // Flights after truck: groups truckGroupIndex + 1, truckGroupIndex + 2, ...
                groupIndex = index + 1;
            }
            
            return {
                id: flight?.awb_id,
                group: groupIndex,
                content: `
                    <div>
                        <img src="${Planedash}" alt="Flight" />
                        <span>${flight?.connected_flight_no}</span>
                        <span>${flight?.origin || ''} - ${flight?.destination || ''}</span>
                        <p>${flight?.departure_date_time_flight?.split(' ')[1]} - ${flight?.arrival_date_time_flight?.split(' ')[1]}</p>
                        <em>${flight?.import_export}</em>
                    </div>`,
                start: flight?.departure_date_time_flight || '',
                end: flight?.arrival_date_time_flight || '',
                className: 'dashbord_blu flight',
            };
        }) || [];
        
        // Create truck item for timeline - positioned in the middle
        const truckItem = {
            id: `truck-${innerData.booking_data?.booking_truck_details?.id || clickedItem.id}`,
            group: truckGroupIndex, // Truck in the middle group
            content: `
                <div>
                    <img src="${Truckdash}" alt="Truck" />
                    <span>${innerData.booking_data?.booking_truck_details?.bookingtruck_no || clickedItem.truck_number}</span>
                    <span>${innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || clickedItem.loading_station} - ${innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || clickedItem.unloading_station}</span>
                    <p>${innerData.booking_data?.departure_time || ''} - ${innerData.booking_data?.arrival_time || ''}</p>
                </div>`,
            start: truckDepartureDateTime,
            end: truckArrivalDateTime,
            className: 'dashbord_blu truck',
        };
        
        // Combine truck and flights in trucksList (truck first, then flights)
        const trucksList = [truckItem, ...flightItems];
        
        const structuredData = {
            truck_number: innerData.booking_data?.booking_truck_details?.bookingtruck_no || clickedItem.truck_number,
            loading_station: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || clickedItem.loading_station,
            unloading_station: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || clickedItem.unloading_station,
            loading_name: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || clickedItem.loading_station,
            unloading_name: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || clickedItem.unloading_station,
            loading_date_scheduled: truckDepartureDateTime,
            unloading_date_scheduled: truckArrivalDateTime,
            uld_number: clickedItem.id,
            connected_flights: innerData,
            trucksList: trucksList, // Now includes both truck and flights
        };

        // Only update timeline view for double click, don't touch side panel
        setFilteredItems([structuredData]);
        setShowFlightDetails(true);
        setClickedFlight(structuredData);
        
    } catch (error) {
        console.error('Error fetching connected flights:', error);
    } finally {
        setDisLoading(false);
    }
};


useEffect(() => {
    if (!timelineRef.current) return;

    if (!timelineInstanceRef.current) {
        // Use the selectedDate if it exists, otherwise use current date
        const initialDate = selectedDate || new Date(2025, 7, 12);
        const timelineStart = new Date(initialDate);
        timelineStart.setHours(0, 0, 0, 0);
        const timelineEnd = new Date(initialDate);
        timelineEnd.setHours(23, 59, 59, 999);

        const options = {
            stack: true,
            margin: { item: 10, axis: 10 },
            start: timelineStart,
            end: timelineEnd,
            editable: false,
            zoomable: true,
            horizontalScroll: true,
            itemHeight: 51,
            // minHeight: '85dvh', //commented for auto height
            orientation: { axis: 'both', item: 'bottom' },
            zoomMin: showFlightDetails ? 1200000 : 86400000,
            zoomMax: 432000000  // 432000000, 172800000 for 2 days max, 432000000 for 5 days max
        };

        const timelineInstance = new Timeline(timelineRef.current, [], [], options);
        timelineInstanceRef.current = timelineInstance;
        setTimeline(timelineInstance);

        let isUserInteraction = false;
        let isInitialized = false; // Add flag to track initialization
        
        timelineInstance.on('rangechange', () => { 
            isUserInteraction = true; 
        });
        
        timelineInstance.on('rangechanged', (props) => {
            // Skip the first rangechanged event during initialization
            if (!isInitialized) {
                isInitialized = true;
                return;
            }
            
            if (isUserInteraction && !showFlightDetails) {
                const { start, end } = props;
                const rangeInDays = (end - start) / (1000 * 60 * 60 * 24);
                if (rangeInDays >= 1) {
                    fetchTruckData(start, end);
                }
                isUserInteraction = false;
            }
        });

        timelineInstance.on('changed', () => {
            requestAnimationFrame(drawConnections);
        });

        return () => {
            timelineInstance.destroy();
            timelineInstanceRef.current = null;
        };
    }
}, []);


useEffect(() => {
    const timelineInstance = timelineInstanceRef.current;
    if (!timelineInstance) return;

    let displayItems = [];
    let displayGroups = [];

    if (showFlightDetails && filteredItems?.[0]?.trucksList) {
        displayItems = filteredItems[0].trucksList;
        
        // Find the truck item to get its group ID
        const truckItem = filteredItems[0].trucksList.find(item => item.className?.includes('truck'));
        const truckGroupId = truckItem?.group ?? 0;
        
        // Create unique groups from items to avoid duplicate group IDs
        const uniqueGroups = new Map();
        let flightNumber = 1; // Start flight numbering from 1
        
        // First, collect all group IDs and sort them
        const allGroupIds = [...new Set(filteredItems[0].trucksList.map(item => 
            item.group !== undefined && item.group !== null ? item.group : 0
        ))].sort((a, b) => a - b);
        
        // Create groups in order, assigning sequential flight numbers
        allGroupIds.forEach((groupId) => {
            const isTruck = groupId === truckGroupId;
            uniqueGroups.set(groupId, {
                id: groupId,
                content: isTruck ? 'Truck' : `Flight ${flightNumber++}`,
            });
        });
        
        // Groups are already sorted by ID, so truck appears in the middle
        // Timeline displays groups in ID order, which we've ensured is correct
        displayGroups = allGroupIds.map(id => uniqueGroups.get(id)).filter(Boolean);
    } else {
        displayItems = getTruckData?.length > 0
            ? getTruckData
                  .map((item) => {
                      const group = groups.find((g) => g.content === item.loading_station)?.id || null;
                      if (!group) return null;
                      return {
                          id: item.id,
                          group,
                          content: `
                            <div>
                                <img src="${Truckdash}" alt="Truck" />
                                <span>${item.truck_number}</span>
                                <span>${item.loading_station} - ${item.unloading_station}</span>
                                <p>${item.loading_date_planned?.split(' ')[1]} - ${item.unloading_date_planned?.split(' ')[1]}</p>
                            </div>`,
                          start: item.loading_date_planned,
                          end: item.unloading_date_planned,
                          className: 'dashbord_blu',
                      };
                  })
                  .filter(Boolean)
            : [];

        displayGroups = groups;
    }

    try {
        timelineInstance.setItems(displayItems);
        timelineInstance.setGroups(displayGroups);
        
        if (selectedDate && selectedDate !== prevSelectedDate) {
            const timelineStart = new Date(selectedDate);
            timelineStart.setHours(0, 0, 0, 0);
            const timelineEnd = new Date(selectedDate);
            timelineEnd.setHours(23, 59, 59, 999);
            timelineInstance.setWindow({ start: timelineStart, end: timelineEnd });
            setPrevSelectedDate(selectedDate);
        }

        setTimeout(() => {
            drawConnections();
        }, 200);
    } catch (err) {
        console.error('Error updating timeline:', err);
    }

}, [getTruckData, groups, filteredItems, showFlightDetails, selectedDate, prevSelectedDate]);


useEffect(() => {
    const timelineInstance = timelineInstanceRef.current;
    if (!timelineInstance) return;

    let clickTimeout = null;
    const clickDelay = 250;

    timelineInstance.off('click');
    timelineInstance.off('doubleClick');

    timelineInstance.on('click', (properties) => {
        if (clickTimeout) clearTimeout(clickTimeout);
        clickTimeout = setTimeout(() => {
            if (properties.item && !showFlightDetails) {
                const clickedItem = getTruckData.find((item) => item.id === properties.item);
                if (clickedItem) {
                    console.log("Single click:", clickedItem);
                    handleSidePanelClick(clickedItem);
                }
            }
            clickTimeout = null;
        }, clickDelay);
    });

    timelineInstance.on('doubleClick', (properties) => {
        if (clickTimeout) {
            clearTimeout(clickTimeout);
            clickTimeout = null;
        }
        if (!showFlightDetails && properties.item) {
            const clickedItem = getTruckData.find((item) => item.id === properties.item);
            if (clickedItem) {
                console.log("Double click:", clickedItem);
                handleDoubleClickForTimeline(clickedItem);
            }
        }
    });

    return () => {
        if (clickTimeout) clearTimeout(clickTimeout);
    };
}, [getTruckData, showFlightDetails]);





// const handleSidePanelClick = async (item) => {
//     if (!showFlightDetails) {
//         if (timelineDisplay === 'F') {
//             setSelectedFlightDetails(item);
//         } else {
//             setDisLoading(true);
//             try {
//                 const res = await withRFSToken.post('booking-truck/connected-flights', { 
//                     bookingtruck_date_id: item.id 
//                 });
//                 const innerData = res.data.response_data;
                
//                 const structuredData = {
//                     truck_number: innerData.booking_data?.booking_truck_details?.bookingtruck_no || item.truck_number,
//                     loading_station: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || item.loading_station,
//                     unloading_station: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || item.unloading_station,
//                     loading_name: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || item.loading_station,
//                     unloading_name: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || item.unloading_station,
//                     loading_date_scheduled: `${innerData.booking_data?.departure_date} ${innerData.booking_data?.departure_time}`,
//                     loading_date_actual: `${innerData.booking_data?.departure_date} ${innerData.booking_data?.departure_time}`,
//                     unloading_date_scheduled: `${innerData.booking_data?.arrival_date} ${innerData.booking_data?.arrival_time}`,
//                     unloading_date_actual: `${innerData.booking_data?.arrival_date} ${innerData.booking_data?.arrival_time}`,
//                     uld_number: item.id,
//                     connected_flights: innerData, 
//                     trucksList: innerData?.awbs?.map((flight, index) => ({
//                         id: flight?.awb_id,
//                         group: index + 1,
//                         content: `<div><img src="${Planedash}" alt="Flight" /><span>${flight?.connected_flight_no}</span><span>${flight?.origin || ""} - ${flight?.destination || ""}</span><p>${flight?.departure_date_time_flight?.split(' ')[1]} - ${flight?.arrival_date_time_flight?.split(' ')[1]}</p><em>${flight?.import_export}</em></div>`,
//                         start: flight?.departure_date_time_flight || "",
//                         end: flight?.arrival_date_time_flight || "",
//                         className: 'dashbord_blu flight',
//                         awb_id: flight?.awb_id,
//                         airway_bill: flight?.airway_bill,
//                         connection_time: flight?.connection_time || ""
//                     })) || []
//                 };

//                 setSelectedFlightDetails(structuredData);
//                 setDisLoading(false);
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//                 setDisLoading(false);
//             }
//         }
//     }
// };


// const handleSidePanelClick = async (item) => {
//     if (!showFlightDetails) {
//         if (timelineDisplay === 'F') {
//             setSelectedFlightDetails(item);
//         } else {
//             setDisLoading(true);
//             try {
//                 const res = await withRFSToken.post('booking-truck/connected-flights', { 
//                     bookingtruck_date_id: item.id 
//                 });
//                 const innerData = res.data.response_data;
                
//                 const structuredData = {
//                     truck_number: innerData.booking_data?.booking_truck_details?.bookingtruck_no || item.truck_number,
//                     loading_station: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || item.loading_station,
//                     unloading_station: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || item.unloading_station,
//                     loading_name: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || item.loading_station,
//                     unloading_name: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || item.unloading_station,
//                     loading_date_scheduled: `${innerData.booking_data?.departure_date} ${innerData.booking_data?.departure_time}`,
//                     loading_date_actual: `${innerData.booking_data?.departure_date} ${innerData.booking_data?.departure_time}`,
//                     unloading_date_scheduled: `${innerData.booking_data?.arrival_date} ${innerData.booking_data?.arrival_time}`,
//                     unloading_date_actual: `${innerData.booking_data?.arrival_date} ${innerData.booking_data?.arrival_time}`,
//                     uld_number: item.id,
//                     connected_flights: innerData, 
//                     trucksList: innerData?.awbs?.map((flight, index) => ({
//                         id: flight?.awb_id,
//                         group: index + 1,
//                         content: `<div><img src="${Planedash}" alt="Flight" /><span>${flight?.connected_flight_no}</span><span>${flight?.origin || ""} - ${flight?.destination || ""}</span><p>${flight?.departure_date_time_flight?.split(' ')[1]} - ${flight?.arrival_date_time_flight?.split(' ')[1]}</p><em>${flight?.import_export}</em></div>`,
//                         start: flight?.departure_date_time_flight || "",
//                         end: flight?.arrival_date_time_flight || "",
//                         className: 'dashbord_blu flight',
//                         awb_id: flight?.awb_id,
//                         airway_bill: flight?.airway_bill,
//                         connection_time: flight?.connection_time || ""
//                     })) || []
//                 };

//                 setSelectedFlightDetails(structuredData);
//                 setDisLoading(false);
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//                 setDisLoading(false);
//             }
//         }
//     }
// };


const handleSidePanelClick = async (item) => {
    if (!showFlightDetails) {
        if (timelineDisplay === 'F') {
            setSelectedFlightDetails(item);
        } else {
            setDisLoading(true);
            try {
                const res = await withRFSToken.post('booking-truck/connected-flights', { 
                    bookingtruck_date_id: item.id 
                });
                const innerData = res.data.response_data;
                
                const truckDepartureDateTime = `${innerData.booking_data?.departure_date} ${innerData.booking_data?.departure_time}`;
                const truckArrivalDateTime = `${innerData.booking_data?.arrival_date} ${innerData.booking_data?.arrival_time}`;
                
                const flightCount = innerData?.awbs?.length || 0;
                const truckGroupIndex = Math.floor(flightCount / 2);
                
                const truckItem = {
                    id: `truck-${innerData.booking_data?.booking_truck_details?.id || item.id}`,
                    group: truckGroupIndex,
                    content: `<div><img src="${Truckdash}" alt="Truck" /><span>${innerData.booking_data?.booking_truck_details?.bookingtruck_no || item.truck_number}</span><span>${innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || item.loading_station} - ${innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || item.unloading_station}</span><p>${innerData.booking_data?.departure_time || ''} - ${innerData.booking_data?.arrival_time || ''}</p></div>`,
                    start: truckDepartureDateTime,
                    end: truckArrivalDateTime,
                    className: 'dashbord_blu truck',
                };
                
                const flightItems = innerData?.awbs?.map((flight, index) => {
                    let groupIndex;
                    if (index < truckGroupIndex) {
                        groupIndex = index;
                    } else {
                        groupIndex = index + 1;
                    }
                    
                    return {
                        id: flight?.awb_id,
                        group: groupIndex,
                        content: `<div><img src="${Planedash}" alt="Flight" /><span>${flight?.connected_flight_no}</span><span>${flight?.origin || ""} - ${flight?.destination || ""}</span><p>${flight?.departure_date_time_flight?.split(' ')[1]} - ${flight?.arrival_date_time_flight?.split(' ')[1]}</p><em>${flight?.import_export}</em></div>`,
                        start: flight?.departure_date_time_flight || "",
                        end: flight?.arrival_date_time_flight || "",
                        className: 'dashbord_blu flight',
                        awb_id: flight?.awb_id,
                        airway_bill: flight?.airway_bill,
                        connection_time: flight?.connection_time || ""
                    };
                }) || [];
                
                const structuredData = {
                    truck_number: innerData.booking_data?.booking_truck_details?.bookingtruck_no || item.truck_number,
                    loading_station: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || item.loading_station,
                    unloading_station: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || item.unloading_station,
                    loading_name: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || item.loading_station,
                    unloading_name: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || item.unloading_station,
                    loading_date_scheduled: truckDepartureDateTime,
                    loading_date_actual: truckDepartureDateTime,
                    unloading_date_scheduled: truckArrivalDateTime,
                    unloading_date_actual: truckArrivalDateTime,
                    uld_number: item.id,
                    connected_flights: innerData, 
                    trucksList: [truckItem, ...flightItems]
                };

                setSelectedFlightDetails(structuredData);
                setDisLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setDisLoading(false);
            }
        }
    }
};
    const detailsClick = () => {

        setFilteredItems([selectedFlightDetails]);
        setShowFlightDetails(true);
        setClickedFlight(selectedFlightDetails);
        setSelectedFlightDetails(null);

        const fromId = selectedFlightDetails.trucksList[0]?.id;
        const toConnections = selectedFlightDetails.trucksList.slice(1).map((item) => ({
            from: fromId,
            to: item.id,
        }));

        // console.log('toConnections', toConnections);

        // setConnections(toConnections);
        //     const svg = svgRef.current;
        //     if (!svg) return;
        //     svg.innerHTML = '';

        //     toConnections.forEach(({ from, to }) => {
        //     const fromItem = filteredItems.find(item => item.id === from);
        //     const toItem = filteredItems.find(item => item.id === to);
        //     console.log('fromItem', fromItem);

        //     // const toItem = filteredItems.itemSet.items[to];


        //     if (fromItem && toItem) {
        //         console.log('timeline==2', timeline);
        //         const fromElement = timeline.itemSet.items[from]?.dom.box;
        //         // const fromElement = timelineRef.current?.timeline.getItem(from);
        //         const toElement = timeline.itemSet.items[to]?.dom.box;
        //         // const toElement = timelineRef.current?.timeline.getItem(to);
        //         console.log('fromElement:', fromElement);
        //         console.log('toElement:', toElement);
        //         if (fromElement && toElement) {
        //             const fromRect = fromItem.getBoundingClientRect();
        //             const toRect = toItem.getBoundingClientRect();
        //             console.log('fromRect:', fromRect);
        //             console.log('toRect:', toRect);
        //             // const fromRect = fromItem.dom.box.getBoundingClientRect();
        //             // const toRect = toItem.dom.box.getBoundingClientRect();

        //             // Calculate positions for the start and end of the line
        //             const startX = fromRect.right; // Right edge of the "from" item
        //             const startY = fromRect.top + fromRect.height / 2; // Middle of the "from" item
        //             const endX = toRect.left; // Left edge of the "to" item
        //             const endY = toRect.top + toRect.height / 2; // Middle of the "to" item

        //             // Create an SVG path for a smooth curve
        //             const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        //             path.setAttribute('d', `M${startX},${startY} C${(startX + endX) / 2},${startY} ${(startX + endX) / 2},${endY} ${endX},${endY}`);
        //             path.setAttribute('stroke', 'gray');
        //             path.setAttribute('stroke-width', '1');
        //             path.setAttribute('fill', 'none');

        //             svg.appendChild(path);
        //         }
        //     }
        // });

    }



// const handleDoubleClick = async (properties, getTruckData, withRFSToken, setDisLoading, setFilteredItems, setShowFlightDetails, setClickedFlight) => {
//     if (!properties.item) return;

//     const clickedItem = getTruckData.find((item) => item.id === properties.item);
//     if (!clickedItem) return;

//     try {
//         setDisLoading(true);
//         const res = await withRFSToken.post('booking-truck/connected-flights', {
//             bookingtruck_date_id: clickedItem.id,
//         });

//         const innerData = res.data.response_data;
        
//         // Create truck datetime strings
//         const truckDepartureDateTime = `${innerData.booking_data?.departure_date} ${innerData.booking_data?.departure_time}`;
//         const truckArrivalDateTime = `${innerData.booking_data?.arrival_date} ${innerData.booking_data?.arrival_time}`;
        
//         // Create truck item for timeline
//         const truckItem = {
//             id: `truck-${innerData.booking_data?.booking_truck_details?.id || clickedItem.id}`,
//             group: 0, // Truck in group 0
//             content: `
//                 <div>
//                     <img src="${Truckdash}" alt="Truck" />
//                     <span>${innerData.booking_data?.booking_truck_details?.bookingtruck_no || clickedItem.truck_number}</span>
//                     <span>${innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || clickedItem.loading_station} - ${innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || clickedItem.unloading_station}</span>
//                     <p>${innerData.booking_data?.departure_time || ''} - ${innerData.booking_data?.arrival_time || ''}</p>
//                 </div>`,
//             start: truckDepartureDateTime,
//             end: truckArrivalDateTime,
//             className: 'dashbord_blu truck',
//         };
        
//         // Create flight items for timeline
//         const flightItems = innerData?.awbs?.map((flight, index) => ({
//             id: flight?.awb_id,
//             group: index + 1, // Flights in groups 1, 2, 3, etc.
//             content: `
//                 <div>
//                     <img src="${Planedash}" alt="Flight" />
//                     <span>${flight?.connected_flight_no}</span>
//                     <span>${flight?.origin || ''} - ${flight?.destination || ''}</span>
//                     <p>${flight?.departure_date_time_flight?.split(' ')[1]} - ${flight?.arrival_date_time_flight?.split(' ')[1]}</p>
//                     <em>${flight?.import_export}</em>
//                 </div>`,
//             start: flight?.departure_date_time_flight || '',
//             end: flight?.arrival_date_time_flight || '',
//             className: 'dashbord_blu flight',
//         })) || [];
        
//         // Combine truck and flights in trucksList
//         const trucksList = [truckItem, ...flightItems];
        
//         const structuredData = {
//             truck_number: innerData.booking_data?.booking_truck_details?.bookingtruck_no || clickedItem.truck_number,
//             loading_station: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || clickedItem.loading_station,
//             unloading_station: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || clickedItem.unloading_station,
//             loading_name: innerData.booking_data?.booking_truck_details?.board_point_station?.station_code || clickedItem.loading_station,
//             unloading_name: innerData.booking_data?.booking_truck_details?.off_point_station?.station_code || clickedItem.unloading_station,
//             loading_date_scheduled: truckDepartureDateTime,
//             unloading_date_scheduled: truckArrivalDateTime,
//             uld_number: clickedItem.id,
//             connected_flights: innerData,
//             trucksList: trucksList, // Now includes both truck and flights
//         };

//         setFilteredItems([structuredData]);
//         setShowFlightDetails(true);
//         setClickedFlight(structuredData);
        
//     } catch (error) {
//         console.error('Error fetching connected flights:', error);
//     } finally {
//         setDisLoading(false);
//     }
// };

    const DisplayChange = (event) => {
        setShowFlightDetails(false);
        setFilteredItems(null);
        setTimelineDisplay(event.target.value);
        setSelectedFlightDetails()
    }
    const handleSortBy = (event) => {
        const sortBy = event.target.value;

    }

    // Function to draw SVG lines
    // const drawLines = (container, sourceItem, allItems) => {
    //     // Remove existing SVG
    //     const existingSvg = container.querySelector(".custom-lines");
    //     if (existingSvg) {
    //         existingSvg.remove();
    //     }

    //     // Create SVG element
    //     const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    //     svg.setAttribute("class", "custom-lines");
    //     svg.setAttribute("width", "100%");
    //     svg.setAttribute("height", "100%");
    //     svg.style.position = "absolute";
    //     svg.style.top = "0";
    //     svg.style.left = "0";
    //     svg.style.pointerEvents = "none";

    //     // Locate source element by its content
    //     const sourceElement = findItemByContent(container, sourceItem.content);
    //     if (!sourceElement) return;

    //     const sourceRect = sourceElement.getBoundingClientRect();

    //     allItems.forEach((item) => {
    //         if (item.id !== sourceItem.id && item.group === 2) {
    //             // Locate target element by its content
    //             const targetElement = findItemByContent(container, item.content);
    //             if (!targetElement) return;

    //             const targetRect = targetElement.getBoundingClientRect();

    //             // Calculate line positions
    //             const startX = sourceRect.left + sourceRect.width / 2;
    //             const startY = sourceRect.bottom;
    //             const endX = targetRect.left + targetRect.width / 2;
    //             const endY = targetRect.top;

    //             // Create line
    //             const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
    //             line.setAttribute("x1", `${startX}`);
    //             line.setAttribute("y1", `${startY}`);
    //             line.setAttribute("x2", `${endX}`);
    //             line.setAttribute("y2", `${endY}`);
    //             line.setAttribute("stroke", "#ccc");
    //             line.setAttribute("stroke-width", "2");
    //             line.setAttribute("stroke-dasharray", "5, 5"); // Optional dashed style
    //             svg.appendChild(line);
    //         }
    //     });

    //     container.appendChild(svg);
    // };
    // Helper function to find timeline item by content
    const findItemByContent = (container, content) => {
        const items = container.querySelectorAll(".vis-item");
        return Array.from(items).find((item) => item.textContent?.includes(content));
    };

    // useEffect(() => {
    //     // if (!timeline || !connections.length) return;
    //     console.log('timeline==1', timeline);
    //     if (filteredItems) {
    //         // const container = timelineRef.current.querySelector('.vis-panel.vis-center'); // Timeline container
    //         const container = timelineRef.current;
    //         const svg = svgRef.current;
    //         if (!svg) return;
    //         svg.innerHTML = ''; // Clear previous lines

    //         connections.forEach(({ from, to }) => {
    //             // const fromItem = filteredItems.find(item => item.id === from);
    //             // const toItem = filteredItems.find(item => item.id === to);
    //             const fromElement = container.querySelectorAll('.vis-item')[from - 1];
    //             const toElement = container.querySelectorAll('.vis-item')[to - 1];
    //             // console.log('fromItem', fromItem);

    //             // const toItem = filteredItems.itemSet.items[to];

    //             // if (fromItem && toItem) {
    //                 console.log('timeline==2', timeline);
    //                 // const fromElement = timeline.itemSet.items[from]?.dom.box;
    //                 // const fromElement = timelineRef.current?.timeline.getItem(from);
    //                 // const toElement = timeline.itemSet.items[to]?.dom.box;
    //                 // const toElement = timelineRef.current?.timeline.getItem(to);
    //                 console.log('fromElement:', fromElement);
    //                 console.log('toElement:', toElement);
    //                 if (fromElement && toElement) {
    //                     const fromRect = fromElement.getBoundingClientRect();
    //                     const toRect = toElement.getBoundingClientRect();
    //                     console.log('fromRect:', fromRect);
    //                     console.log('toRect:', toRect);
    //                     // const fromRect = fromItem.dom.box.getBoundingClientRect();
    //                     // const toRect = toItem.dom.box.getBoundingClientRect();

    //                     const containerRect = container.getBoundingClientRect();

    //       // Create an SVG line
    //       const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
    //       line.setAttribute("x1", fromRect.right - containerRect.left);
    //       line.setAttribute("y1", fromRect.top + fromRect.height / 2 - containerRect.top);
    //       line.setAttribute("x2", toRect.left - containerRect.left);
    //       line.setAttribute("y2", toRect.top + toRect.height / 2 - containerRect.top);
    //       line.setAttribute("stroke", "black");
    //       line.setAttribute("stroke-width", "1");
    //       svg.appendChild(line);
    //                 }
    //             // }
    //         });
    //     }
    // }, [filteredItems, connections, timeline]);

    const zoomIn = () => {
        if (timeline) {
            const range = timeline.getWindow();
            const interval = range.end - range.start;
            timeline.setWindow({
                start: new Date(range.start.getTime() + interval * 0.1), // Zoom in 10%
                end: new Date(range.end.getTime() - interval * 0.1),
            });
        }
    };

    // Function to zoom out
    const zoomOut = () => {
        if (timeline) {
            const range = timeline.getWindow();
            const interval = range.end - range.start;
            timeline.setWindow({
                start: new Date(range.start.getTime() - interval * 0.1), // Zoom out 10%
                end: new Date(range.end.getTime() + interval * 0.1),
            });
        }
    };

    const updateCurrentTime = () => {
        setCurrentTime(new Date());
    };
    const handleCloseClick = () => {
        setSelectedFlightDetails(null);
    };

    // const statusColors = {
    //     Arrived: '#8bc34a', // Green
    //     'En Route': '#2196f3', // Blue
    //     Delayed: '#ff9800', // Orange
    //     Scheduled: '#4caf50', // Dark Green
    //   };
    // const flightYPosition = (index) => 50 + index * 60;

    //     useEffect(() => {
    //         const container = timelineRef.current;
    //         const timeline = new Timeline(container, allItems, groups);

    //         // Add the SVG layer
    //         const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    //         svg.setAttribute('style', 'position:absolute; top:0; left:0; width:100%; height:100%; pointer-events:none;');
    //         svgRef.current = svg;
    //         container.appendChild(svg);

    //         timeline.on('changed', () => drawConnections(timeline));
    //     }, []);

    //     // Draw connections with SVG paths
    //     const drawConnections = (timeline) => {
    //         const svg = svgRef.current;
    //         if (!svg) return;
    //         svg.innerHTML = ''; // Clear previous paths

    //         const connections = [
    //             { from: 2, to: 1 },
    //             { from: 3, to: 1 },
    //             { from: 4, to: 1 },
    //         ];
    // console.log('timeline',timeline);

    //         connections.forEach(({ from, to }) => {
    //             const fromElement = timeline.items[from]?.dom.box;
    //             const toElement = timeline.items[to]?.dom.box;

    //             if (fromElement && toElement) {
    //                 const fromRect = fromElement.getBoundingClientRect();
    //                 const toRect = toElement.getBoundingClientRect();

    //                 const startX = fromRect.right;
    //                 const startY = fromRect.top + fromRect.height / 2;
    //                 const endX = toRect.left;
    //                 const endY = toRect.top + toRect.height / 2;

    //                 const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    //                 path.setAttribute(
    //                     'd',
    //                     `M${startX},${startY} C${(startX + endX) / 2},${startY} ${(startX + endX) / 2},${endY} ${endX},${endY}`
    //                 );
    //                 path.setAttribute('stroke', 'gray');
    //                 path.setAttribute('stroke-width', '1');
    //                 path.setAttribute('fill', 'none');

    //                 svg.appendChild(path);
    //             }
    //         });
    //     };

    // FILE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);


    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }

    // const imageModalUpload = (id) => {
    //     const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    //     setFiles(selectedRowFiles);
    //     setSelectedRowId(id); // Store the ID of the selected row
    //     setShowModalUpload(true);
    // };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // FILE UPLOAD END

    return (
        <>
            {console.log('allItems', selectedStation)}
            {console.log("selectedFlightDetailssss",selectedFlightDetails)}
            {/* {console.log('timeline', timeline)} */}
            {console.log('groups', groups)}
            <div className="dashboard">
                <Header logo_url='/BookingtruckSchedule' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab d-flex justify-content-between align-items-center">
                            <div className="nestedtabs rounded">
                                <div className='d-flex'>
                                    <div>
                                        <div style={{ position: 'relative' }}>
                                            <div onClick={toggleCalendar} className='clendericon'>
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </div>
                                            {showCalendar && (
                                                <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 9999, }}>
                                                    <DatePicker
                                                        selected={selectedDate}
                                                        onChange={handleSelect}
                                                        inline
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="calendar-container schedule_calender">
                                        <div className="scrollable-calendar">
                                            <button className='btnleft' onClick={handlePrevious}> <FontAwesomeIcon icon={faChevronLeft} /> </button>
                                            {[...Array(daysToShow)].map((_, index) => {
                                                const date = new Date(getStartDate());
                                                date.setDate(getStartDate().getDate() + index);
                                                return (
                                                    <div key={index} className={`day ${isCurrentDate(date) ? 'current-date' : ''}`} onClick={(event) => handleDayClick(date, event)}>
                                                        <div className="day-name">{getDayName(date)}</div>
                                                        <div className="date"> {getMonthAbbreviation(date)} {date.getDate()}</div>
                                                    </div>
                                                );
                                            })}
                                            <button className='btnright' onClick={handleNext}> <FontAwesomeIcon icon={faChevronRight} /> </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-end truck_filter">

                                {/* <div className="d-flex tuck_short">

                                    <Form.Group className="me-2">
                                        <Form.Label>Display</Form.Label>
                                        <Form.Select aria-label="Select" onChange={(event) => DisplayChange(event)}>
                                            <option value="T">Truck</option>
                                            <option value='F'>Flights</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group >
                                        <Form.Label>Sort By</Form.Label>
                                        <Form.Select aria-label="Select" onChange={(event) => handleSortBy(event)}>
                                            <option>Sorted by Origin</option>
                                            <option value="L">Loading Station</option>
                                            <option value="U">Unloading Station</option>
                                        </Form.Select>
                                        <MultiSelect
                                            options={getStation}
                                            // value={getStation.filter(item => formData.unloading_station?.includes(item.station_id))}
                                            value={selectedStation}
                                            onChange={setSelectedStation}
                                            labelledBy="Select "
                                            className='multiselect'
                                            disabled = {timelineDisplay !== 'T' ? true : ''}
                                        />
                                    </Form.Group>


                                </div> */}
                                {/* <div className="ms-2"><button type="button" class="btn btn-primary truck_search" onClick={handleFilter}><FontAwesomeIcon icon={faMagnifyingGlass} /> Search</button></div> */}


                                {/* <div className="chart_filter ms-2" > <Link to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight2" aria-controls="offcanvasRight"> <img src={Filter} ></img> </Link> </div>

                                <div className="offcanvas offcanvas-end dashbord_side" tabindex="-1" id="offcanvasRight2" aria-labelledby="offcanvasRightLabel">
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    <div className="offcanvas-header rafilter">
                                        <h3>Filter Properties</h3>
                                        <p>Select Properties that you want to see inside the chart</p>
                                    </div>
                                    <div className="offcanvas-body">

                                        <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Loading Station</Form.Label>
                                            <Form.Select aria-label="Default select example">
                                                <option>Open this select menu</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Unloading Station</Form.Label>
                                            <Form.Select aria-label="Default select example">
                                                <option>Open this select menu</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Form.Group>


                                        <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Trucker Name</Form.Label>
                                            <Form.Select aria-label="Default select example">
                                                <option>Open this select menu</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <div className='text-center filter_update'>
                                            <Button variant="light" className='stk_cancel' >CANCEL</Button>
                                            <Button variant="primary" className='stk_save posr' >UPDATE</Button>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="ms-2 truck_plas">
                                    <button type="button" class="btn btn-light" onClick={zoomOut}> <FontAwesomeIcon icon={faMinus} /> </button>
                                    <button type="button" class="btn btn-light ms-2" onClick={zoomIn}><FontAwesomeIcon icon={faPlus} /></button>

                                </div>


                            </div>
                            {/* <CargoDamage />                        */}
                        </div>
                        {showFlightDetails && <Link to="#" onClick={() => setShowFlightDetails(false) && setFilteredItems(null)} className='stk_back mt-3 d-block'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>}
                        <div className={`maindiv mt-3 overflow-hidden ${timelineDisplay == 'T' ? 'position-relative' : ''}`}>
                            {disLoading &&
                                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                            }
                            <div className={`mb-0 nestedtabs rounded trashdonload min_h ${timelineDisplay == 'F' ? 'clip-hide' : ''}`}>
                                <div ref={timelineRef}></div>{/* style={{ height: '400px' }} */}

                                {showFlightDetails && (
                                    <>
                                        {/* <Link to="#" className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link> */}
                                        <svg ref={svgRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }} />
                                        {/* <button onClick={() => setShowFlightDetails(false)} style={{ marginTop: '20px' }}>
                                            Back to All Flights
                                        </button> */}
                                    </>
                                )}
                            </div>
                            {selectedFlightDetails && (
                                <div className="SecondDiv">
                                    {/* {console.log('selectedFlightDetails', selectedFlightDetails)} */}
                                    <button className="close" onClick={handleCloseClick}>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                    <div className="girddtals_header">
                                        <h3>{timelineDisplay === 'T' ? selectedFlightDetails.truck_number : selectedFlightDetails.content}</h3>
                                        <div className='d-flex actbtn'>

                                            <Button variant="light" > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>{/* onClick={browseClick} */}
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                                    <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item>Option</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {/* {timelineDisplay == 'F' ? */}
                                                <Button variant="light" onClick={detailsClick}> <FontAwesomeIcon icon={faPaperclip} /> Details</Button>
                                                {/* : ''
                                            } */}
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-between my-3'>
                                        <div className='order_view'>
                                            <h3>{selectedFlightDetails.loading_station}</h3>
                                            {/* <span>{selectedFlightDetails.loading_name}</span> */}
                                            <span>
                                                {selectedFlightDetails.loading_name && selectedFlightDetails.loading_name.length > 20
                                                    ? `${selectedFlightDetails.loading_name.slice(0, 20)}...`
                                                    : selectedFlightDetails.loading_name}
                                            </span>
                                            <div className='mt-3'>
                                                <p>Scheduled - <b>{selectedFlightDetails.loading_date_scheduled} <span></span></b>  </p> {/**CEST */}
                                                <p>Actual - <b>{selectedFlightDetails.loading_date_actual} <span></span></b> </p> {/**CEST */}
                                            </div>
                                        </div>
                                        <div className='order_middle'>
                                            <p><img src={Cargotruck} /></p>
                                            <span>{selectedFlightDetails.truck_number}</span>
                                        </div>
                                        <div className='order_view'>
                                            <h3>{selectedFlightDetails.unloading_station}</h3>
                                            {/* <span>{selectedFlightDetails.unloading_name}</span> */}
                                            <span>
                                                {selectedFlightDetails.unloading_name && selectedFlightDetails.unloading_name.length > 20
                                                    ? `${selectedFlightDetails.unloading_name.slice(0, 20)}...`
                                                    : selectedFlightDetails.unloading_name}
                                            </span>
                                            <div className='mt-3'>
                                                <p>Scheduled - <b>{selectedFlightDetails.unloading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                                <p>ETA - <b>{selectedFlightDetails.unloading_date_actual} <span></span></b> {/*CEST*/}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='mb-3'>
                                        <ProgressBar animated now={50} style={{ height: "5px" }} />
                                    </div>
                                    {/* {timelineDisplay == 'T' ?
                                        <>
                                            <div className='movment_history'>
                                                <h3>Status Updates</h3> 
                                            </div>
                                            <div className='movment_list'>
                                                <ul>
                                                    {selectedFlightDetails && selectedFlightDetails?.status_updates.map((history, index) => (
                                                        <li>
                                                            <span className='movem w-auto'>{history.status}</span>
                                                            <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                                                            
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                        :
                                        <div className="planemap">
                                            <img src={Planemap} />
                                        </div>
                                    } */}

                                    {timelineDisplay == 'T' && selectedFlightDetails?.connected_flights?.awbs && selectedFlightDetails.connected_flights?.awbs?.length > 0 ? (
    <>
        <div className='movment_history'>
           <h3>Status Updates</h3>
           {console.log("selectedFlightDetailssss",selectedFlightDetails)}
        </div>
        <div className='movment_list'>
            <ul>
                {selectedFlightDetails?.connected_flights?.awbs?.map((flight, index) => (
                    
                    <li key={flight.awb_id}>
                        {console.log("flightttt",flight)}
                        <span className='movem w-auto'>{flight.connected_flight_no}</span>
                        <span className='mvdate'>{flight.origin} - {flight.destination}</span>
                        <span className='mvdate'>{flight.connected_flight_date}</span>
                        <span className='mvdate'>AWB: {flight.airway_bill}</span>
                    </li>
                ))}
            </ul>
        </div>
    </>
)  : (
    <div className="planemap">
        <img src={Planemap} />
    </div>
)}
                                    <ImageUpload
                                        ref={imageUploadRef}
                                        attachable_type={"uld"}
                                        attachable_id={selectedFlightDetails.uld_number}
                                        attachments={selectedFlightDetails.attachments}
                                    // onDeleteSuccess={() => loadDetails(selectedFlightDetails.uld_number)}
                                    />
                                    <ActivityComments
                                        commentable_type={"uld"}
                                        commentable_id={selectedFlightDetails.uld_number}
                                        allactivities={selectedFlightDetails.activities}
                                    // onReloadDetails={loadDetails}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >

        </>
    );

}
export default RFSDashboard;